import React, { createContext, useCallback, useEffect, useMemo, useState } from 'react';
import * as companyService from '../services/companyService';
import { toast } from 'react-toastify';

export const CompanyContext = createContext(null);

export function CompanyProvider({ children }) {
	const [company, setCompany] = useState(null);
	const [companyToken, setCompanyToken] = useState(() => localStorage.getItem('companyToken') || '');
	const [loading, setLoading] = useState(false);

	const loginCompany = useCallback(async (email, password) => {
		setLoading(true);
		try {
			const res = await companyService.loginCompany(email, password);
			localStorage.setItem('companyToken', res.token);
			setCompanyToken(res.token);
			setCompany(res.company);
			toast.success('Logged in');
			return true;
		} catch (err) {
			toast.error(err?.response?.data?.message || 'Login failed');
			return false;
		} finally {
			setLoading(false);
		}
	}, []);

	const logoutCompany = useCallback(() => {
		localStorage.removeItem('companyToken');
		setCompanyToken('');
		setCompany(null);
		toast.info('Logged out');
	}, []);

	const updateCompany = useCallback(async () => {
		if (!companyToken) return;
		try {
			const res = await companyService.getCompanyProfile();
			setCompany(res.company);
		} catch {
			// ignore
		}
	}, [companyToken]);

	useEffect(() => {
		(async () => {
			if (!companyToken) return;
			setLoading(true);
			try {
				const res = await companyService.getCompanyProfile();
				setCompany(res.company);
			} catch {
				localStorage.removeItem('companyToken');
				setCompanyToken('');
			} finally {
				setLoading(false);
			}
		})();
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	const value = useMemo(() => ({ company, companyToken, loading, loginCompany, logoutCompany, updateCompany }), [company, companyToken, loading, loginCompany, logoutCompany, updateCompany]);

	return <CompanyContext.Provider value={value}>{children}</CompanyContext.Provider>;
}


